import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

const styles = () => ({
  root: {
    '& table': {
      border: 'none',
      borderCollapse: 'collapse',
      width: '100%',
      verticalAlign: 'center',
      '& tr': {
      },
      '& td': {
        paddingTop: '12px',
        paddingBottom: '12px',
      },
      '& td:first-child': {
        width: '305px',
        paddingRight: '16px',
        borderRight: '1px solid #ccc',
        textAlign: 'right',
      },

      '& td:last-child': {
        paddingLeft: '16px',
      },
    },
  },
});


const InCardTwoColumnTableWrapper = (props) => {
  const { classes, children } = props;
  return (
    <div className={classes.root}>
      {children}
    </div>
  );
};

InCardTwoColumnTableWrapper.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
  children: PropTypes.instanceOf(Object).isRequired,
};

export default withStyles(styles)(InCardTwoColumnTableWrapper);
